"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Sustainability() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".secure-eyebrow", {
        y: 16
      });
      gsap.set(".secure-word", {
        y: 32
      });
      gsap.set(".secure-body", {
        y: 20
      });
      gsap.set(".secure-cta", {
        y: 20
      });
      const tl = gsap.timeline({
        defaults: {
          ease: "power3.out",
          duration: 0.72
        },
        delay: 0.15
      });
      tl.to(".secure-eyebrow", {
        opacity: 1,
        y: 0
      }).to(".secure-word", {
        opacity: 1,
        y: 0,
        stagger: 0.04,
        duration: 0.8
      }, "-=0.4").to(".secure-body", {
        opacity: 1,
        y: 0
      }, "-=0.35").to(".secure-cta", {
        opacity: 1,
        y: 0
      }, "-=0.35");
      gsap.to(".secure-ground", {
        xPercent: 3,
        yPercent: -2,
        duration: 22,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
      gsap.to(".secure-ground-inner", {
        opacity: 1,
        duration: 1.2,
        ease: "power2.out"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".secure-eyebrow", ".secure-word", ".secure-body", ".secure-cta"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".secure-ground-inner", {
        opacity: 1
      });
    });
  }, {
    scope: container
  });
  const headlineWords = ["Engenharia", "sustentável.", "Eficiência", "industrial."];
  return <section data-section-id="26823" ref={container} id="sustainabilityconsultationcta" data-nav="light" className="relative isolate overflow-hidden bg-background text-foreground min-h-[72vh] py-32 md:py-44">
      {}
      <div className="secure-ground absolute inset-0 -z-10 pointer-events-none">
        <div className="secure-ground-inner absolute inset-0" style={{
        opacity: 0,
        background: "radial-gradient(ellipse 80% 70% at 85% 15%, hsl(215 80% 20% / 0.1) 0%, hsl(215 90% 45% / 0.05) 30%, hsl(210 20% 98% / 0.85) 65%, hsl(210 20% 98%) 100%)"
      }} />
        <div className="absolute inset-0" style={{
        background: "radial-gradient(circle at 20% 90%, hsl(210 20% 98%) 0%, transparent 55%)"
      }} />
        {}
        <div className="absolute inset-0 mix-blend-overlay opacity-[0.05]" style={{
        backgroundImage: "radial-gradient(hsl(215 12% 40% / 0.3) 1px, transparent 1px)",
        backgroundSize: "3px 3px"
      }} />
      </div>

      {}
      <div className="absolute top-0 right-0 h-full w-1/2 -z-10 pointer-events-none" style={{
      background: "linear-gradient(225deg, hsl(215 90% 45% / 0.08) 0%, transparent 60%)"
    }} />

      <div className="relative mx-auto max-w-[900px] px-6 md:px-10 text-center">
        {}
        <p className="secure-eyebrow font-default text-xs uppercase mb-8 md:mb-10" style={{
        opacity: 0,
        color: "hsl(215 90% 45%)",
        letterSpacing: "0.22em",
        fontWeight: 600
      }}>
          Compromisso Eurocontrol
        </p>

        {}
        <h1 className="font-default text-foreground mb-8 md:mb-10" style={{
        fontSize: "clamp(2.75rem, 5.4vw + 0.5rem, 6.5rem)",
        letterSpacing: "-0.035em",
        lineHeight: 0.98,
        fontWeight: 700
      }}>
          {headlineWords.map((word, i) => <span key={i} data-index={i} className="secure-word inline-block mr-[0.25em] last:mr-0" style={{
          opacity: 0
        }}>
              {word}
            </span>)}
        </h1>

        {}
        <p className="secure-body font-default mx-auto mb-10 md:mb-14 max-w-[640px]" style={{
        opacity: 0,
        color: "hsl(215 12% 40%)",
        fontSize: "clamp(1.0625rem, 0.35vw + 1rem, 1.1875rem)",
        lineHeight: 1.55,
        fontWeight: 400,
        letterSpacing: "-0.005em"
      }}>
          Otimizamos processos industriais para reduzir desperdícios e maximizar a performance com tecnologia de ponta.
        </p>

        {}
        <div className="secure-cta flex justify-center" style={{
        opacity: 0
      }}>
          <Button asChild className="group h-auto rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg px-7 py-[18px] text-base font-medium w-full max-w-[320px] sm:w-auto sm:max-w-none" style={{
          letterSpacing: "-0.005em"
        }}>
            <Link to="/ContactsPage" className="inline-flex items-center gap-3">
              <span>Consulte-nos</span>
              <span className="inline-flex items-center justify-center rounded-lg size-7 transition-transform duration-[260ms] ease-out group-hover:-rotate-45" style={{
              border: "1px solid hsl(210 20% 98% / 0.24)"
            }}>
                <ArrowUpRight className="size-4" style={{
                color: "hsl(210 20% 98%)"
              }} strokeWidth={2} />
              </span>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}